module.exports = __webpack_public_path__ + "static/media/CAMS_POCS_list.d945ca7e.pdf";